module.exports = "https://cdn.realtymogul.com/static/media/HP_hero_LA.5cc74378.jpg";